import React from 'react';
import {Table} from 'reactstrap';

const sortTypes = {
	up: {
		class: 'sort-up',
	},
	down: {
		class: 'sort-down',
	},
	default: {
		class: 'sort',
	}
};

class ProductsList extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			currentSort: 'default',
			sortField: '',
			isExpanded: false,
		}
	}

	onSortChange = (field) => {
		const { currentSort } = this.state;
		let nextSort;

		if (currentSort === 'down') nextSort = 'up';
		else if (currentSort === 'up') nextSort = 'default';
		else if (currentSort === 'default') nextSort = 'down';

		this.setState({
			currentSort: nextSort,
			sortField: field
		});
	};

	processData = () => {
		const {sortField, currentSort} = this.state;

		var ret = [];
		this.props.products.forEach(p => {
			if (p.Category === this.props.category) {
				ret.push(p);
			}
		});
		if (sortField === '') {
			ret.sort((a, b) => {return a.Name > b.Name ? 1 : -1});
		} else {
			switch(currentSort) {
				case 'up':
					ret.sort((a, b) => {return a[sortField] > b[sortField] ? -1 : 1});
					break;
				case 'down':
					ret.sort((a, b) => {return a[sortField] > b[sortField] ? 1 : -1});
					break;
				default:
					ret.sort((a, b) => {return a.Name > b.Name ? 1 : -1});
			}
		}
		return ret;
	}

	quantityTitle = (date) => {
		var nextDay = new Date(date);
		nextDay.setDate(date.getDate() + 1);
		var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug',
								  'Sep', 'Oct', 'Nov', 'Dec'];
		return 'Quantity required for week beginning ' +
			months[nextDay.getMonth()] + ' ' + nextDay.getDate();
	}

	getDayOfWeek = (dayNumber) => {
		switch(dayNumber) {
			case 0: return 'S';
			case 1: return 'M';
			case 2: return 'T';
			case 3: return 'W';
			case 4: return 'T';
			case 5: return 'F';
			case 6: return 'S'
		}
		return '';
	}

	toggleExpand = () => {
		const {isExpanded} = this.state;
		this.setState({isExpanded : !isExpanded})
	}

	render() {
		const { currentSort, sortField, isExpanded } = this.state;
		var currentWeekTitle = this.quantityTitle(this.props.currentWeek);
		var plus1WeekTitle = this.quantityTitle(this.props.plus1Week);
		var plus2WeeksTitle = this.quantityTitle(this.props.plus2Weeks);
		var plus3WeeksTitle = this.quantityTitle(this.props.plus3Weeks);
		var data = this.processData();
		console.log(data)
		return (
			<>
				<div className={`grid-table tablesorter ${isExpanded ? 'expandeded' : ''} ${this.props.forecastCurrent == 'Future estimates' ? 'isFuture' : ''}`}>
					{/* HEADER */}
					<div className={`sortable`}
						onClick={() => this.onSortChange('Name')}>
						Item Name &nbsp;
						{
							sortField === 'Name' &&
								<i className={`fas fa-${sortTypes[currentSort].class}`}/>
						}
						{
							sortField !== 'Name' &&
								<i className={`fas fa-${sortTypes['default'].class}`}/>
						}
					</div>
					<div className={`sortable`}
						onClick={() => this.onSortChange('Code')}>
						Item Code &nbsp;
						{
							sortField === 'Code' &&
								<i className={`fas fa-${sortTypes[currentSort].class}`}/>
						}
						{
							sortField !== 'Code' &&
								<i className={`fas fa-${sortTypes['default'].class}`}/>
						}
					</div>
					{ this.props.forecastCurrent !== 'Future estimates' ?
						<><div title={`${currentWeekTitle}`} className={`sortable`}
							onClick={() => this.onSortChange('CurrentWeekQuantity')}>
							This Week &nbsp;
							{
								sortField === 'CurrentWeekQuantity' &&
									<i className={`fas fa-${sortTypes[currentSort].class}`}/>
							}
							{
								sortField !== 'CurrentWeekQuantity' &&
									<i className={`fas fa-${sortTypes['default'].class}`}/>
							}
						</div>
						<div title={`${plus1WeekTitle}`} className={`sortable`}
							onClick={() => this.onSortChange('Plus1WeekQuantity')}>
							+1 Week &nbsp;
							{
								sortField === 'Plus1WeekQuantity' &&
									<i className={`fas fa-${sortTypes[currentSort].class}`}/>
							}
							{
								sortField !== 'Plus1WeekQuantity' &&
									<i className={`fas fa-${sortTypes['default'].class}`}/>
							}
						</div>
						<div title={`${plus2WeeksTitle}`} className={`sortable`}
							onClick={() => this.onSortChange('Plus2WeeksQuantity')}>
							+2 Weeks &nbsp;
							{
								sortField === 'Plus2WeeksQuantity' &&
									<i className={`fas fa-${sortTypes[currentSort].class}`}/>
							}
							{
								sortField !== 'Plus2WeeksQuantity' &&
									<i className={`fas fa-${sortTypes['default'].class}`}/>
							}
						</div>
						<div title={`${plus3WeeksTitle}`} className={`sortable`}
							onClick={() => this.onSortChange('Plus3WeeksQuantity')}>
							+3 Weeks &nbsp;
							{
								sortField === 'Plus3WeeksQuantity' &&
									<i className={`fas fa-${sortTypes[currentSort].class}`}/>
							}
							{
								sortField !== 'Plus3WeeksQuantity' &&
									<i className={`fas fa-${sortTypes['default'].class}`}/>
							}
						</div></>
						: null
					}
					<div title="Total Quantity Required" className={`sortable`}
						onClick={() => this.onSortChange('Quantity')}>
						Total &nbsp;
						{
							sortField === 'Quantity' &&
								<i className={`fas fa-${sortTypes[currentSort].class}`}/>
						}
						{
							sortField !== 'Quantity' &&
								<i className={`fas fa-${sortTypes['default'].class}`}/>
						}
					</div>
						{/* END HEADER */}

					{ data.map(d => {
						return (
							<>
								<div style={{borderRight: '1px solid white'}}>{d.Name}</div>
								<div>{d.Code}</div>
								{ this.props.forecastCurrent !== 'Future estimates' ?
									<><div style={{display: 'flex', gap: '5px', cursor: 'pointer'}} onClick={this.toggleExpand}><span>ALL: <br/>{d.CurrentWeekQuantity}</span>
										{
											isExpanded && d.CurrentWeekDays.map((q, day) => {
												return (
													<div>
														<div>{this.getDayOfWeek(day)}<br />{q}</div>
													</div>
												)
											})

										}
									</div>
									<div style={{display: 'flex', gap: '5px', cursor: 'pointer'}} onClick={this.toggleExpand}>
										<span>ALL<br/>{d.Plus1WeekQuantity}</span>
										{
											isExpanded && d.Plus1WeekDays.map((q, day) => {
												return (
													<div>
														<div>{this.getDayOfWeek(day)}<br/>{q}</div>
													</div>
												)
											})

										}
									</div>
									<div>All<br/>{d.Plus2WeeksQuantity}</div>
									<div>All<br/>{d.Plus3WeeksQuantity}</div></>
									: null
								}
								<div>{d.Quantity}</div>
							</>
						)
					})}

				</div>
			</>
		);
	}
}

export default ProductsList;
